import { Box, Skeleton, Text } from '@salestrak/ui'
import { InfoTooltip } from './InfoTooltip'
import { DrilldownMemberTag } from './DrilldownGroupTitle'
import type { DashboardLabels, LeaderboardEntry } from '#app/lib/data'
const SKELETON_ROW_CLASS = 'h-5 w-full'

interface KnockLeaderboardProps {
  entries: LeaderboardEntry[] | null | undefined
  labels: DashboardLabels | null | undefined
}

export function KnockLeaderboard({ entries, labels }: KnockLeaderboardProps) {
  const loading = !entries

  return (
    <Box rounded="xl" border padding="md" surface="card">
      <Box direction="row" gap="xs" align="center">
        <Text size="sm" weight="medium" variant="muted">Top {labels?.contactVerb ? `${labels.contactVerb.charAt(0).toUpperCase()}${labels.contactVerb.slice(1)}s` : ''}</Text>
        <InfoTooltip>
          Reps ranked by total {labels?.contactVerb}s in the selected period.
        </InfoTooltip>
      </Box>
      <Box paddingTop="sm">
        <Box direction="column" gap="xs">
          {loading ? (
            Array.from({ length: 5 }, (_, i) => (
              <Skeleton key={i} className={SKELETON_ROW_CLASS} />
            ))
          ) : entries.length === 0 ? (
            <Text size="sm" weight="medium">No data</Text>
          ) : (
            entries.map((rep, i) => (
              <Box direction="row" key={`${rep.userId}-${i}`} justify="between" align="center">
                <Box direction="row" gap="xs" align="center">
                  <Text size="xs" weight="bold" variant="muted">{i + 1}</Text>
                  <DrilldownMemberTag userId={rep.userId} name={rep.name} size="sm" weight="regular" />
                </Box>
                <Text size="sm" weight="semibold">{rep.count}</Text>
              </Box>
            ))
          )}
        </Box>
      </Box>
    </Box>
  )
}
